import React from 'react';
import SvgIcon from './SvgIcon';

/**
 * @param {FF.SvgIcon} props
 */
function CouponIcon(props) {
  return (
    <SvgIcon viewBox="0 0 60 60" {...props}>
      <title>Coupon Icon</title>
      <g>
        <path d="M53.525 28.95L31.025 6.45C30.125 5.55 28.875 5 27.5 5H10C7.25 5 5 7.25 5 10V27.5C5 28.875 5.55 30.125 6.475 31.05L28.975 53.55C29.875 54.45 31.125 55 32.5 55C33.875 55 35.125 54.45 36.025 53.525L53.525 36.025C54.45 35.125 55 33.875 55 32.5C55 31.125 54.425 29.85 53.525 28.95ZM13.75 17.5C11.675 17.5 10 15.825 10 13.75C10 11.675 11.675 10 13.75 10C15.825 10 17.5 11.675 17.5 13.75C17.5 15.825 15.825 17.5 13.75 17.5Z" />
      </g>
    </SvgIcon>
  );
}

export default CouponIcon;
